<template>
  <el-dialog
    width="800"
    class="de-dialog-form"
    :visible.sync="visible"
    :title="'[' + deviceParam.deviceName + ']' + '选择指标'"
    @closed="cancelModal"
  >
    <div style="display: flex; margin-top: 15px">
      <div>
        <group
          @switchComponent="switchComponent"
          groupType="zb"
          :heightDis="true"
          ref="group"
        />
      </div>
      <div style="flex: 1">
        <el-table element-loading-text="加载中" :data="dataSource" border>
          <!-- <el-table-column type="selection" width="55"></el-table-column> -->
          <el-table-column label="指标名称" align="center" prop="name" />
          <el-table-column label="原始名称" align="center" prop="originName" />
          <el-table-column label="指标来源" align="center" prop="source" />
        </el-table>
      </div>
    </div>
    <div slot="footer" style="margin-top: 15px">
      <el-button @click="cancelModal">取 消</el-button>
      <el-button type="primary" @click="modalSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { fieldListDQ } from "@/api/dataset/dataset";
import * as API_Ques from "@/api/dataAccess/accessApi";
import Group from "../group/Group";
export default {
  components: {
    Group,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    deviceId: {
      type: String | Number,
      default: "",
    },
    deviceParam: {
      type: Object,
    },
  },
  watch: {
    deviceId: function () {
      this.init();
    },
  },
  data() {
    return {
      dataSource: [],
      columns: [
        {
          title: "指标名称",
          dataIndex: "name",
          key: "name",
          align: "center",
          width: 80,
        },
        {
          title: "原始名称",
          dataIndex: "originName",
          key: "originName",
          align: "center",
          width: 80,
        },
        {
          title: "指标来源",
          dataIndex: "source",
          key: "source",
          align: "center",
          width: 80,
        },
      ],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
      },
      title: "",
      // 数据集
      dataSetParam: {},
    };
  },
  created() {},
  mounted() {},
  methods: {
    modalSubmit() {
      // console.log(this.deviceParam, '父组件设备的对象');
      // console.log(this.dataSetParam, "子组件数据集对象");
      let data = {
        datasetTableId: this.dataSetParam.id,
        deviceId: this.deviceParam.deviceId,
      };
      console.log(data);
      API_Ques.saveDeviceDataset(data).then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.$message.success(res.msg);
          // ps: 关闭弹窗，转递子组件ID，更改父组件datasetTableId的值，触发实时更新
          this.$emit("cancel", this.dataSetParam.id);
          // console.log(this.$refs.group);
          // console.log(this.dataSetParam.id,'zi');
          // console.log(this.deviceParam.datasetTableId,'fu');
          // this.$parent.$parent.getDeviceFieldList(this.dataSetParam.id);
          //this.dataSetParam.id
          // this.$refs.group.getDeviceTreeList()
        }
      });
    },
    cancelModal() {
      this.$emit("cancel");
    },
    switchComponent(e) {
      console.log(e);
      const { param } = e;
      this.dataSetParam = e.param;
      this.getTableList(param.id);
    },
    // 页码变动
    handleTableChange(paginationData) {
      const { pageSize, current } = paginationData;
      this.pagination.pageSize = pageSize;
      this.pagination.current = current;
      this.getTableList();
    },
    getTableList(id) {
      fieldListDQ(id).then((res) => {
        const { data, success } = res;
        if (success) {
          const { quotaList } = data;
          this.dataSource = quotaList;
        }
      });
    },
    rowSelectionFun() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(
            `selectedRowKeys: ${selectedRowKeys}`,
            "selectedRows: ",
            selectedRows
          );
        },
        onSelect: (record, selected, selectedRows) => {
          console.log(record, selected, selectedRows);
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          console.log(selected, selectedRows, changeRows);
        },
      };
    },
  },
  computed: {
    // deviceParam() {
    //   return this.deviceParam
    // },
  },
};
</script>
